<div [@animation]="animationState">
  <div class="sidebar__navbar">
    <div class="sidebar__navbar_container">
      <rp-home-menu-burger (click)="onClose()" />
    </div>
  </div>

  <div class="sidebar__body">
    <div class="sidebar__body_actions">
      <ui-button
        [fullWidth]="true"
        appereance="stroked"
        [label]="'general.signIn' | translate"
        size="m"
        (click)="navigateToSignIn()"
      />
      <ui-button
        appereance="flat"
        [fullWidth]="true"
        [label]="'general.getStarted' | translate"
        size="m"
        (click)="navigateToSignUp()"
      />
      <ui-select
        class="sidebar__body_language-selector"
        isLanguageSelector
        [formControl]="languageControl"
        [items]="languages"
      />
    </div>
  </div>
</div>
